import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'demo-collapse-item',
  standalone: true,
  imports: [CommonModule, LocalLoaderComponent],
  templateUrl: './demo-collapse-item.component.html',
  styleUrl: './demo-collapse-item.component.scss',
})
export class DemoCollapseItemComponent implements OnInit {
  @Input() data!: {
    term: string;
  };

  isLoading$ = new BehaviorSubject(true);

  ngOnInit(): void {
    setTimeout(() => {
      this.isLoading$.next(false);
    }, 250);
  }
}
